const alertStatus = new Set(["app.delete", "rejected", "invalidate"]);
const successStatus = new Set(["approved"]);

export default function TimelineEvents({ items = [], title = true, data = [] }) {
    const filteredItems = items.filter((item) => !!item.dt);
    const status = new Map((data ?? []).map((item) => [item.time_action, item.action]));

    return (
        <div
            className={[
                "relative space-y-3",
                "before:content-[''] before:absolute before:left-[calc(8.75rem+1.5rem+22px)]",
                "before:top-5.5 before:bottom-5.5 before:w-1 before:rounded before:bg-slate-700",
                "print:before:hidden",
            ].join(" ")}
        >
            {filteredItems.map((item, index) => {
                const [datePart, timePart] = String(item.dt).split(" ");
                const itemStatus = item?.status ?? status.get(item.dt);

                return (
                    <div key={"timeline-" + index} className="relative flex items-center gap-6">
                        <div
                            className={[
                                "hidden print:absolute print:left-[calc(8.75rem+1.5rem+22px)] print:block print:w-1 print:bg-slate-700",
                                index === 0 ? "print:top-1/2" : "print:top-[-1rem]",
                                index === filteredItems.length - 1 ? "print:bottom-1/2" : "print:bottom-[-1rem]",
                            ].join(" ")}
                        />

                        <section className={"flex break-inside-avoid items-center gap-6 print:break-inside-avoid print:[page-break-inside:avoid]"}>
                            <div className="w-35.5 text-right text-zinc-500 font-semibold leading-tight text-base">
                                <div>{datePart}</div>
                                <div>{timePart}</div>
                            </div>

                            <div className="relative flex w-11 flex-col items-center">
                                <div
                                    className={[
                                        "relative z-10 flex h-11 w-11 items-center justify-center rounded-full border-3 border-zinc-200",
                                        alertStatus.has(itemStatus?.toLowerCase()) ? "bg-red-700" : item?.delayed ? "bg-red-600" : "bg-slate-700",
                                        successStatus.has(itemStatus?.toLowerCase()) ? "bg-green-700!" : "",
                                    ].join(" ")}
                                    title={title ? (item?.delayed ? "Atrasado" : "No prazo") : undefined}
                                >
                                    { !item.removeIcon && (
                                        <img
                                            src={item.icon}
                                            alt=""
                                            className="h-5 w-5 object-contain select-none"
                                            draggable={false}
                                        />
                                    )}
                                </div>
                            </div>
                        </section>

                        <div
                            className={[
                                "relative flex-1 mr-10 rounded-md bg-zinc-100 px-6 py-4 text-zinc-500 text-base font-semibold",
                                "before:content-[''] before:absolute before:left-0 before:top-1/2 before:-translate-y-1/2",
                                "before:-translate-x-2 before:border-y-10 before:border-y-transparent before:border-r-10 before:border-r-slate-100",
                            ].join(" ")}
                        >
                            <div className="flex items-center justify-between gap-6">
                                <div className="min-w-0 flex-1">
                                    <div>{item.text}</div>

                                    {!!item.questions?.length && (
                                        <div className="mt-1 space-y-2">
                                            <div className="text-zinc-500 text-[14px]">
                                                Questões:
                                            </div>

                                            {item.questions.map((question, questionIndex) => (
                                                <div key={questionIndex} className="text-[13px] -mt-1">
                                                    <div>{question.question}</div>
                                                    <div>
                                                        - {question.answer ?? "Sem resposta"}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>

                                {item.image && (
                                    <div className="shrink-0">
                                        <img
                                            src={item.image}
                                            alt=""
                                            className="h-15 w-30 object-cover"
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}